import { render, staticRenderFns } from "./CmgPasswordResetRequestPage.vue?vue&type=template&id=1d607a18&scoped=true&lang=pug"
import script from "./cmg-password-reset-request-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-password-reset-request-page.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgPasswordResetRequestPage.vue?vue&type=style&index=0&id=1d607a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d607a18",
  null
  
)

export default component.exports